import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

export class NotificationsRealtimeClient {
  constructor(hubUrl, getToken) {
    this.hubUrl = hubUrl;
    this.getToken = getToken;
    this.connection = null;
  }

  async connect({ onReceived, onConnected, onDisconnected, onError }) {
    if (this.connection) return;

    this.connection = new HubConnectionBuilder()
      .withUrl(this.hubUrl, {
        accessTokenFactory: () => this.getToken() || '',
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    this.connection.on('notification:received', (payload) => {
      if (onReceived) onReceived(payload);
    });

    this.connection.onreconnected(() => {
      if (onConnected) onConnected();
    });

    this.connection.onclose((err) => {
      if (onDisconnected) onDisconnected();
    });

    try {
      await this.connection.start();
      if (onConnected) onConnected();
    } catch (e) {
      if (onError) onError(e);
      this.connection = null;
    }
  }

  async disconnect() {
    if (!this.connection) return;

    const c = this.connection;
    this.connection = null;

    try {
      await c.stop();
    } catch {
      console.error('Error disconnecting from notifications hub');
    }
  }
}
